// extracted by mini-css-extract-plugin
export default {"notFound-container":"notFound_notFound-container__Cgso3","opacity":"notFound_opacity__azG5j"};